import { render, staticRenderFns } from "./MyConnections.vue?vue&type=template&id=2cb1401a&scoped=true"
import script from "./MyConnections.vue?vue&type=script&lang=js"
export * from "./MyConnections.vue?vue&type=script&lang=js"
import style0 from "./MyConnections.vue?vue&type=style&index=0&id=2cb1401a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb1401a",
  null
  
)

export default component.exports